import Cookies from 'js-cookie'

const ROOT_DOMAIN = '.miaobi.cn'

export function getCookieDomain(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }
  const hostname = window.location.hostname
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  ) {
    return undefined
  }
  if (hostname === 'miaobi.cn' || hostname.endsWith('.miaobi.cn')) {
    return ROOT_DOMAIN
  }
  return undefined
}

export function cookieAttrs(extra: Record<string, any> = {}): Record<string, any> {
  const domain = getCookieDomain()
  const attrs: Record<string, any> = { path: '/', ...extra }
  if (domain) {
    attrs.domain = domain
  }
  return attrs
}

export function setCookie(name: string, value: any, extra: Record<string, any> = {}) {
  Cookies.remove(name)
  return Cookies.set(name, value, cookieAttrs(extra))
}

export function removeCookie(name: string) {
  Cookies.remove(name)
  return Cookies.remove(name, cookieAttrs())
}
